import { render, staticRenderFns } from "./IndexGeneral.vue?vue&type=template&id=69486d12&"
import script from "./IndexGeneral.vue?vue&type=script&lang=js&"
export * from "./IndexGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports